<template>
    <div class="GSC_main" :style="mainColors">
        <div class="container">
            <section class="page-section">
                <div class="row">
                    <div class="col">
                        <GreenLabel :title="'Privacy Policy'" :color="'var(--main-color)'" :extraClass="'roboto'"/>
                    </div>
                </div>
                <div class="row page-text p-8">
                    <div class="col" :style="mainColor">
                        <PrivacyText :linkColor="linkColor"></PrivacyText>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import GreenLabel from "../components/GreenLabel.vue"
export default {
    name: "PrivacyPolicy",
    components: {
        GreenLabel,
    },
    data() {
        return {
            app_name: document.querySelector('title').text,
            mainColor: themeSettings.general.main_color.value,
            buttonHoverBgColor: themeSettings.general.button_hover_bg_color.value,
            buttonHoverColor: themeSettings.general.button_hover_color.value,
            linkColor: themeSettings.general.link_color.value,
        };
    },
    computed: {
        mainColors() {
            return {
                '--main-color': this.mainColor,
                '--main-button-hover-bg-color': this.buttonHoverBgColor,
                '--main-button-hover-color': this.buttonHoverColor,
                '--link-color': this.linkColor
            };
        },
    },
}
</script>

<style lang="scss" scoped>
    @import "../../sass/pages.scss";
</style>
